/* Complete Workwear — product page interactivity
   Variant selection, quantity, gallery thumbs, and the portal-request modal. */
(function () {
  'use strict';

  function initSection(section) {
    var sectionId = section.getAttribute('data-section-id');

    /* ---------- variant data ---------- */
    var dataEl = section.querySelector('[data-cw-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var idInput = section.querySelector('#cw-variant-id-' + sectionId);
    var atcBtn = section.querySelector('[data-cw-atc]');
    var atcText = section.querySelector('[data-cw-atc-text]');
    var priceEl = section.querySelector('[data-cw-price]');
    var optionInputs = Array.prototype.slice.call(section.querySelectorAll('[data-cw-option]'));
    var mainImg = section.querySelector('#cw-main-image-' + sectionId);

    function setMainImage(url) {
      if (!mainImg || !url) return;
      if (mainImg.getAttribute('src') === url) return;
      mainImg.srcset = '';
      mainImg.src = url;
      // highlight the matching thumbnail if there is one
      section.querySelectorAll('[data-cw-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-full') === url);
      });
    }

    function selectedOptions() {
      var picked = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          var pos = parseInt(input.getAttribute('data-cw-option'), 10) - 1;
          picked[pos] = input.value;
        }
      });
      return picked;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateColourLabels() {
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        var pos = input.getAttribute('data-cw-option');
        var label = section.querySelector('[data-cw-optvalue="' + pos + '"]');
        if (label) label.textContent = input.value;
      });
    }

    function markUnavailableSizes() {
      var opts = selectedOptions();
      var sizeGroup = section.querySelector('.cw-sizes');
      if (!sizeGroup) return;
      var sizeInputs = sizeGroup.querySelectorAll('[data-cw-option]');
      sizeInputs.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-cw-option'), 10) - 1;
        var candidate = opts.slice();
        candidate[pos] = input.value;
        var v = matchVariant(candidate);
        var lbl = section.querySelector('label[for="' + input.id + '"]');
        if (lbl) lbl.classList.toggle('is-unavailable', !(v && v.available));
      });
    }

    function update() {
      updateColourLabels();
      markUnavailableSizes();
      var v = matchVariant(selectedOptions());
      if (idInput && v) idInput.value = v.id;
      if (v && v.image) setMainImage(v.image);
      if (priceEl && v && v.price) priceEl.textContent = v.price;
      if (atcBtn) {
        if (!v || !v.available) {
          atcBtn.setAttribute('disabled', 'disabled');
          if (atcText) atcText.textContent = v ? 'Sold out' : 'Unavailable';
        } else {
          atcBtn.removeAttribute('disabled');
          if (atcText) atcText.textContent = 'Add to Cart';
        }
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (optionInputs.length) update();

    /* ---------- quantity ---------- */
    var qtyInput = section.querySelector('.cw-qty input');
    section.querySelectorAll('[data-cw-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        val += btn.getAttribute('data-cw-qty') === 'up' ? 1 : -1;
        if (val < 1) val = 1;
        qtyInput.value = val;
      });
    });

    /* ---------- gallery thumbs ---------- */
    section.querySelectorAll('[data-cw-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.getAttribute('data-full'));
      });
    });

    /* ---------- portal request modal ---------- */
    var modal = section.querySelector('#cw-portal-modal');
    var openBtn = section.querySelector('[data-cw-open-portal]');
    var closeBtn = section.querySelector('[data-cw-close-portal]');
    if (modal && openBtn) {
      openBtn.addEventListener('click', function () {
        if (modal.showModal) { modal.showModal(); } else { modal.setAttribute('open', ''); }
      });
    }
    if (modal && closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (modal.close) { modal.close(); } else { modal.removeAttribute('open'); }
      });
    }
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) { if (modal.close) modal.close(); }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cw-pdp[data-section-id]').forEach(initSection);
  });
})();
